import { z } from 'zod';
export const photoDtoSchema = z.object({
    id: z.string(),
    url: z.string().url(),
    order: z.number().int(),
});
export const albumDtoSchema = z.object({
    id: z.string(),
    title: z.string(),
    coverUrl: z.string().url(),
    order: z.number().int(),
    photos: z.array(photoDtoSchema),
});
export const createAlbumSchema = z.object({
    title: z.string().trim().min(1).max(80),
    coverUrl: z.string().url(),
    order: z.number().int().default(0),
});
export const createPhotoSchema = z.object({
    albumId: z.string(),
    url: z.string().url(),
    order: z.number().int().default(0),
});
export const updateAlbumSchema = createAlbumSchema.partial();
export const updatePhotoSchema = z.object({
    url: z.string().url().optional(),
    order: z.number().int().optional(),
});
